import React, { useEffect, useRef, useState } from "react";
import CallIcon from "@mui/icons-material/Call";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import GetAppIcon from "@mui/icons-material/GetApp";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  TextField,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useReactToPrint } from "react-to-print";
import { deletethis, get, patch, post } from "../Services/services";
import ReactToPrint from "react-to-print";
import moment from "moment";
import { UserAuthState } from "../Services/RecoilService";
import { useRecoilState } from "recoil";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const aptLogo = require("../utilities/aptLogo.png");
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function OverviewPanel(props) {
  const [tegName, setTagName] = useState([]);
  const [tagId, setTagId] = useState([]);
  const [callStatus, setCallstatus] = useState();
  const [tagData, setTagData] = useState([]);
  const [authState, setAuthState] = useRecoilState(UserAuthState);
  const [activeStatusField, setActiveStatusField] = useState(null);
  const [tempSelectedDate, setTempSelectedDate] = useState(new Date());
  const [gstNumber, setGSTNumber] = useState([])
  const invoiceRef = useRef();
  const location = window.location.pathname;
  const _route = location?.split("/")[2];
  const _currentCase = _route === "open_cases" ? "Open cases" : "Old cases";
  const _currentModule = authState?.userData?.assignModules?.assignModule.find(
    (module) => module.name == _currentCase
  );
  console.log(props?.fetchCase,"fetchhh");
  

  const totalAmount = ((props?.courseData?.courseAmount || 0) - (props?.courseData?.studentDiscount || 0) - (props?.courseData?.bundleDiscount || 0));
  // const CGST = totalAmount * ((parseFloat(props?.courseData?.courses?.tax) / 2) / (100 + (parseFloat(props?.courseData?.courses?.tax) / 2)));
  // const SGST = totalAmount * ((parseFloat(props?.courseData?.courses?.tax) / 2) / (100 + (parseFloat(props?.courseData?.courses?.tax) / 2)));
  const IGST = totalAmount * ((parseFloat(props?.courseData?.courses?.tax)) / (100 + (parseFloat(props?.courseData?.courses?.tax))));
  const CGST = IGST/2;
  const SGST = IGST/2;
  const addTag = async (item) => {
    let body = {
      subscribedCoursesId: props?.courseData?._id,
      tagId: item?.id,
      tag: item?.name,
    };
    const res = await post("subscribedTags", body);
    gettags();
  };
  
  const gettags = async () => {
    const res = await get(
      `subscribedTags?filter={"where":{"subscribedCoursesId":"${props.courseData?._id}"},"include": [{ "relation": "tags" }]}`
    );
    if (res.statusCode === 200) {
      setTagId(res?.data);
    }
  };

  const handleDeleteTag = async (id) => {
    const res = await deletethis(`subscribedTags/${id}`);
    if (res.statusCode === 200) {
      gettags();
    }
  };

  const getTag = async () => {
    const res = await get('tags?filter={"where":{"status":true}}');
    if (res?.statusCode === 200) {
      setTagData(res.data);
    }
  };
  
  // Handle direct date selection when clicking "Yes" button
  const handleDirectDateSelection = (field) => {
    setActiveStatusField(field);
    setTempSelectedDate(new Date());
  };

  // Handle date selection from calendar
  const handleDateSelect = async (field, date) => {
    setTempSelectedDate(date);
    
    // Update the specific field with the selected date
    let updateData = {
      [field]: true,
      [`${field}Date`]: date
    };
    
    const res = await patch(`subscribedCourses/${props?.courseData?._id}`, updateData);
    
    if (res.statusCode === 200) {
      setActiveStatusField(null);
      refreshCase();
    }
  };
  
  const completedWelcomeCall = async () => {
    handleDirectDateSelection('welcomeCall');
  };
  
  const completeAcademicCall = async () => {
    handleDirectDateSelection('academicCall');
  };
  
  const addWhatsappGroup = async () => {
    handleDirectDateSelection('whatsappGroup');
  };
  
  const getStatus = async () => {
    let call;
    let whatsapp;
    let academic;
    
    props.courseData?.admissionProcess?.map((item) => {
      if (
        item?.processName == "Whatsapp group joined" &&
        item?.status !== "pending"
      ) {
        whatsapp = true;
      }
      if (item?.processName == "Welcome call" && item?.status !== "pending") {
        call = item.status;
      }
      if (item?.processName == "Academic call" && item?.status !== "pending") {
        academic = item.status;
      }
    });
    
    setCallstatus({ 
      call: call, 
      whatsapp: whatsapp,
      academic: academic 
    });
  };

  const refreshCase = async () => {
    props.refreshCase();
    getTag();
    gettags();
    getStatus();
  };

    const getGST = async () => {
      const res = await post("fieldTypes/getAllFieldTypeWithField", { status: true });
      
      if (res.statusCode === 200) {
        res.data?.forEach((item) => {
          if (item.title === "GST Number") {
            setGSTNumber(item?.field || []);
          }
        });
      }
    };
  console.log(props?.fetchCase?.case?.statem,"ovverrr");
  
  useEffect(() => {
    refreshCase();
    getGST()
  }, [props?.showNav, props.tabInd]);
  
  useEffect(() => {
    getStatus();
  }, [props.courseData]);

  const handlePrint = useReactToPrint({
    content: () => invoiceRef.current,
  });

  const invoiceColumn =
    props?.fetchCase?.case?.state === "Madhya Pradesh"
      ? ["AMOUNT", "CGST", "SGST", "SUBTOTAL"]
      : ["AMOUNT", "IGST", "SUBTOTAL"];
      

  return (
    <div>
      <Box className="gap-5 flex justify-between flex-wrap">
        <Box className="flex gap-2 items-center">
          <CallIcon />
          <p>Have you completed Welcome call?</p>
          {props?.courseData?.welcomeCall ? (
            <Box className="flex items-center gap-2">
              <CheckCircleIcon className="text-[#4CAF50]" />
              {props?.courseData?.welcomeCallDate && (
                <span className="text-sm text-gray-600">
                  ({moment(props?.courseData?.welcomeCallDate).format("DD/MM/YYYY")})
                </span>
              )}
            </Box>
          ) : (
            <Box>
              {activeStatusField === 'welcomeCall' ? (
                <DatePicker
                  selected={tempSelectedDate}
                  onChange={(date) => handleDateSelect('welcomeCall', date)}
                  onSelect={(date) => handleDateSelect('welcomeCall', date)}
                  dateFormat="dd/MM/yyyy"
                  customInput={
                    <TextField
                      size="small"
                      autoFocus
                      sx={{ width: '150px' }}
                      value={tempSelectedDate ? moment(tempSelectedDate).format("DD/MM/YYYY") : ""}
                    />
                  }
                  onClickOutside={() => setActiveStatusField(null)}
                  shouldCloseOnSelect={true}
                />
              ) : (
                <Button
                  disabled={
                    !(props?.openCases?.update || props?.openCases?.write) ||
                    props.fetchCase?.case?.deleted ||
                    props.courseData?.isRefund ||
                    !_currentModule?.update
                  }
                  onClick={() => completedWelcomeCall()}
                  color="error"
                  size="small"
                  variant="outlined"
                >
                  Yes
                </Button>
              )}
            </Box>
          )}
        </Box>

        <Box className="flex gap-2 items-center">
          <CallIcon />
          <p>Have you completed Academic call?</p>
          {props?.courseData?.academicCall ? (
            <Box className="flex items-center gap-2">
              <CheckCircleIcon className="text-[#4CAF50]" />
              {props?.courseData?.academicCallDate && (
                <span className="text-sm text-gray-600">
                  ({moment(props?.courseData?.academicCallDate).format("DD/MM/YYYY")})
                </span>
              )}
            </Box>
          ) : (
            <Box>
              {activeStatusField === 'academicCall' ? (
                <DatePicker
                  selected={tempSelectedDate}
                  onChange={(date) => handleDateSelect('academicCall', date)}
                  onSelect={(date) => handleDateSelect('academicCall', date)}
                  dateFormat="dd/MM/yyyy"
                  customInput={
                    <TextField
                      size="small"
                      autoFocus
                      sx={{ width: '150px' }}
                      value={tempSelectedDate ? moment(tempSelectedDate).format("DD/MM/YYYY") : ""}
                    />
                  }
                  onClickOutside={() => setActiveStatusField(null)}
                  shouldCloseOnSelect={true}
                />
              ) : (
                <Button
                  disabled={
                    !(props?.openCases?.update || props?.openCases?.write) ||
                    props.fetchCase?.case?.deleted ||
                    props.courseData?.isRefund ||
                    !_currentModule?.update
                  }
                  onClick={() => completeAcademicCall()}
                  color="error"
                  size="small"
                  variant="outlined"
                >
                  Yes
                </Button>
              )}
            </Box>
          )}
        </Box>

        <Box className="flex gap-2 items-center ">
          <WhatsAppIcon className="text-slate-500" />
          <p>Did student join WhatsApp group?</p>
          {props?.courseData?.whatsappGroup ? (
            <Box className="flex items-center gap-2">
              <CheckCircleIcon className="text-[#4CAF50]" />
              {props?.courseData?.whatsappGroupDate && (
                <span className="text-sm text-gray-600">
                  ({moment(props?.courseData?.whatsappGroupDate).format("DD/MM/YYYY")})
                </span>
              )}
            </Box>
          ) : (
            <Box>
              {activeStatusField === 'whatsappGroup' ? (
                <DatePicker
                  selected={tempSelectedDate}
                  onChange={(date) => handleDateSelect('whatsappGroup', date)}
                  onSelect={(date) => handleDateSelect('whatsappGroup', date)}
                  dateFormat="dd/MM/yyyy"
                  customInput={
                    <TextField
                      size="small"
                      autoFocus
                      sx={{ width: '150px' }}
                      value={tempSelectedDate ? moment(tempSelectedDate).format("DD/MM/YYYY") : ""}
                    />
                  }
                  onClickOutside={() => setActiveStatusField(null)}
                  shouldCloseOnSelect={true}
                />
              ) : (
                <Button
                  disabled={
                    !(props?.openCases?.update || props?.openCases?.write) ||
                    props.fetchCase?.case?.deleted ||
                    props.courseData?.isRefund ||
                    !_currentModule?.update
                  }
                  onClick={() => addWhatsappGroup()}
                  color="error"
                  size="small"
                  variant="outlined"
                >
                  Yes
                </Button>
              )}
            </Box>
          )}
        </Box>
        <Box className="flex gap-2 items-center">
          <FormControl className=" w-52" size="small">
            <InputLabel id="demo-multiple-checkbox-label">Tags</InputLabel>
            <Select
              disabled={
                !(props?.openCases?.update || props?.openCases?.write) ||
                props.fetchCase?.case?.deleted ||
                props.courseData?.isRefund ||
                !_currentModule?.update
              }
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              multiple
              value={tegName}
              input={<OutlinedInput label="Tags" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
            >
              {tagData?.map((item) => (
                <MenuItem key={item.name} value={item}>
                  <Checkbox
                    checked={tagId?.findIndex((i) => i.tagId === item.id) > -1}
                    disabled={tagId?.findIndex((i) => i.tagId === item.id) > -1}
                    onChange={() => addTag(item)}
                  />

                  <ListItemText primary={item.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <Box className="flex gap-2 py-5 flex-wrap">
        {tagId?.map((item) => (
          <Box className="p-3 relative" key={item.id}>
            <Box className="p-2 bg-[#66788A1F] text-red-500 border-2 border-red-500 border-opacity-10 rounded-sm">
              <p>{item?.tags?.name}</p>
            </Box>

            {!props?.courseData?.refundStatus && (
              <Box className="absolute -top-1 -right-1 text-red-500 rounded-full p-1 cursor-pointer border-red-500">
                <ClearIcon
                  fontSize="small"
                  onClick={() => handleDeleteTag(item?.id)}
                />
              </Box>
            )}
          </Box>
        ))}
      </Box>
        {console.log(props?.courseData,"courseee")}
      <Box
        className="mt-10 p-5 m-5 border-2 border-[#F1F1F1] "
        ref={invoiceRef}
      >
        <div className="flex justify-between items-center">
          <p className="text-[#585858] font-bold">INVOICE</p>
          <img className="w-10" src={aptLogo} alt="Company Logo" />
        </div>
        <div className="py-5 flex flex-col gap-1">
          <p className="text-[#585858] text-sm">
            161/1, Near Vikramaditya College, Zone-II <br />MP Nagar, Bhopal 
          </p><br />
          <p className="text-[#585858] text-sm">
            GSTIN: {gstNumber?.map((number)=>(
              <p key={number._id}className="inline">
                 {number.title}
              </p>
             
            ))}{" "}
          </p>
          <p className="text-[#585858] text-sm">
            Invoice no.: {props?.courseData?.invoiceNumber}{" "}
          </p><br />
          <p className="text-[#585858] text-sm">
            To : {props?.fetchCase?.case?.name}{" "}
          </p>
          <p className="text-[#585858] text-sm">
            Date : {moment(new Date()).format("L")}{" "}
          </p>
        </div>

                <Box className="bg-[#F4F4F4] flex h-10 px-2 justify-between ">
          <Box className="flex gap-5 px-2">
            <Box className="flex items-center">
              <p className="text-[#585858] text-sm">Course Fee : </p>
              <p className="text-black text-lg">
                {props.courseData?.currency?.currencyName}{" "}
                {props?.courseData?.courseAmount}
              </p>
            </Box>
            <Box className="flex items-center">
              <p className="text-[#585858] text-sm">Bundle Discount : </p>
              <p className="text-black text-lg">
                {props.courseData?.currency?.currencyName}{" "}
                {props?.courseData?.bundleDiscount}
              </p>
            </Box>
            <Box className="flex items-center">
              <p className="text-[#585858] text-sm">Student Discount : </p>
              <p className="text-black text-lg">
                {" "}
                {props.courseData?.currency?.currencyName}{" "}
                {props?.courseData?.studentDiscount}
              </p>
            </Box>
          </Box>
          <Box className="flex items-center">
            <p className="text-[#585858] text-sm">After Discount : </p>
            <p className="text-black text-lg">
              {" "}
              {props.courseData?.currency?.currencyName}{" "}
              {props?.courseData?.courseAmount -
                props?.courseData?.studentDiscount -
                props?.courseData?.bundleDiscount}
            </p>
          </Box>
        </Box>

        <Box className="pt-5 ">
          <TableContainer component={Box}>
            <Table
              sx={{
                border: "2px solid #F1F1F1",
                [`& .${tableCellClasses.root}`]: {
                  borderBottom: "none",
                  borderRight: "2px solid #F1F1F1",
                },
              }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow className="bg-[#F1F1F1]">
                  <TableCell>DESCRIPTION</TableCell>
                  {invoiceColumn?.map((item) => (
                    <TableCell align="right" key={item}>
                      {item} ({props.courseData?.currency?.currencyName})
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow sx={{ borderBottom: "none", borderTop: "none" }}>
                  <TableCell component="th" scope="row">
                    <p className="text-[#585858]">Course:</p>
                  </TableCell>
                  <TableCell align="right"></TableCell>
                  <TableCell align="right"></TableCell>
                  {props?.fetchCase?.case?.state === "Madhya Pradesh" && (
                    <TableCell align="right"></TableCell>
                  )}
                  <TableCell align="right"></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {props.courseData?.courses?.name}
                  </TableCell>
                  {/* Amount  */}
                  <TableCell align="right">
                    {
                      (props?.courseData?.courseAmount - 
                        props?.courseData?.studentDiscount - 
                        props?.courseData?.bundleDiscount) *
                        (100 / (100 + parseFloat(props?.courseData?.courses?.tax)))
                    }
                  </TableCell>

                  {props?.fetchCase?.case?.state === "Madhya Pradesh" ? (
                    <>
                      {/* CGST for MP */}
                      <TableCell align="right">
                      {`${CGST?.toFixed(4)} (${(parseFloat(props?.courseData?.courses?.tax || 0) / 2)}%)`}
                      </TableCell>
                      {/* SGST for MP */}
                      <TableCell align="right">
                      {`${SGST?.toFixed(4)} (${(parseFloat(props?.courseData?.courses?.tax || 0) / 2)}%)`}
                      </TableCell>
                    </>
                  ) : (
                    // IGST for non-MP
                    <TableCell align="right">
                    {`${IGST?.toFixed(4)} (${(parseFloat(props?.courseData?.courses?.tax || 0))}%)`}
                    </TableCell>
                  )}

                  <TableCell align="right">
                    {props.courseData?.currency?.currencyName}{" "}
                    {props?.courseData?.courseAmount -
                      props?.courseData?.studentDiscount -
                      props?.courseData?.bundleDiscount}
                  </TableCell>
                </TableRow>
                <TableRow sx={{ borderTop: "1px solid #F1F1F1" }}>
                  <TableCell component="th" scope="row">
                    <p className="text-[#585858]">Addons:</p>
                  </TableCell>
                  <TableCell align="right"></TableCell>
                  <TableCell align="right"></TableCell>
                  {props?.fetchCase?.case?.state === "Madhya Pradesh" && (
                    <TableCell align="right"></TableCell>
                  )}
                  <TableCell align="right"></TableCell>
                </TableRow>

                {props.courseData?.addOns?.map((row) => (
                  <TableRow
                    key={row.name}
                  >
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>

                    <TableCell align="right">
                    {((row?.price || 0) * (100 / (100 + (row?.tax || 0)))).toFixed(4)}
                      {/* {row?.price - (row?.price / 100) * row?.tax} */}
                    </TableCell>

                    {props?.fetchCase?.case?.state === "Madhya Pradesh" ? (
                      <>
                        {/* CGST for MP */}
                        <TableCell align="right">
                          {`${((row?.price) * ((row?.tax / 2)/(100+(row?.tax / 2))))?.toFixed(4)} (${row?.tax / 2}%)`}
                        </TableCell>
                        {/* SGST for MP */}
                        <TableCell align="right">
                        {`${((row?.price) * ((row?.tax / 2)/(100+(row?.tax / 2))))?.toFixed(4)} (${row?.tax / 2}%)`}
                        </TableCell>
                      </>
                    ) : (
                      // IGST for non-MP
                      <TableCell align="right">
                           {`${((row?.price) * ((row?.tax)/(100+(row?.tax)))).toFixed(4)} (${row?.tax}%)`}
                      </TableCell>
                    )}

                    <TableCell align="right">{row?.price}</TableCell>
                  </TableRow>
                ))}
                <TableRow
                  className="bg-[#F1F1F1]"
                  sx={{ borderTop: "1px solid #F1F1F1" }}
                >
                  <TableCell component="th" scope="row">
                    <p style={{ fontWeight: 400 }}> GRAND TOTAL</p>
                  </TableCell>
                  <TableCell align="right"></TableCell>
                  <TableCell align="right"></TableCell>
                  {props?.fetchCase?.case?.state === "Madhya Pradesh" && (
                    <TableCell align="right"></TableCell>
                  )}
                  <TableCell align="right">
                    <div className="flex gap-2 w-full justify-end">
                      <p style={{ fontWeight: 700 }}>
                        {props.courseData?.currency?.currencyName}{" "}
                        {props?.courseData?.totalFee}
                      </p>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer> <br />
           <p className="text-[#585858] text-sm">
           This is a computer-generated invoice and does not require a physical signature
          </p>
        </Box>
      </Box>
      <div className="flex justify-end">
        <Button
          variant="contained"
          className="flex gap-2"
          onClick={() => {
            handlePrint();
          }}
        >
          <GetAppIcon className="text-[rgb(242,247,246)]" />{" "}
          <p>download Invoice</p>
        </Button>
      </div>
      <div className="h-16 flex justify-end"></div>
    </div>
  );
}